import { CountryCode } from '@shared/types';

/*
  Organization numbers in different countries:
    * Norway - 9 digit
    * Sweden - 10 digits. Hyphen before the last 4 digits.
    * Finland - 8 digits. Hyphen before the last digit.
*/
export const formatOrgNo = (orgNo: string | undefined | null, countryCode: CountryCode): string => {
  if (!orgNo) return '-';

  if (orgNo.length === 8 && countryCode === CountryCode.Finland) {
    return orgNo.substring(0, orgNo.length - 1) + '-' + orgNo.substring(orgNo.length - 1);
  } else if (orgNo.length === 10 && countryCode === CountryCode.Sweden) {
    return orgNo.substring(0, orgNo.length - 4) + '-' + orgNo.substring(orgNo.length - 4);
  } else {
    return orgNo;
  }
};
